import UiSelectOption from "./UiSelectOption";

/**
 * 跟进状态
 * @description 自动生成的代码,请勿修改
 */
export enum EnumCompanyFollowUpRecordStatus {
    /**
     * 待执行
     */
    WaitExec = 10,
    /**
     * 已完成
     */
    Completed = 20,
}

/**
 * 跟进状态-选项
 */
export const EnumCompanyFollowUpRecordStatusOption: UiSelectOption<number>[] = [
    { Label: "待执行", Value: 10, Data: "WaitExec" },
    { Label: "已完成", Value: 20, Data: "Completed" },
];
